import { useMediaQuery } from '@mantine/hooks';

const MOBILE_VIEW_WIDTH = 576;

const useMobile = () => useMediaQuery(`(max-width: ${MOBILE_VIEW_WIDTH}px)`);

export default useMobile;
